import { Product } from '~/Api/Product';

interface ModuleProduct {
	readonly product: Product;
	readonly datasource: {
		readonly suklReference: boolean;
	};
	readonly selected: boolean;
}

interface ModuleProductDataSoruce {
	readonly product: Product;
	readonly referenceDataSource: boolean;
	readonly selected: boolean;
}

export const isSuklReferenceProduct = (product: ModuleProduct) =>
	(!product.datasource.suklReference && !product.selected) ||
	product.product.status.isRemoved() ||
	product.product.status.isBeforeIntroduction();

export const isReferenceDataSource = (product: ModuleProductDataSoruce) =>
	(!product.referenceDataSource && !product.selected) ||
	product.product.status.isRemoved() ||
	product.product.status.isBeforeIntroduction();
